import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import Link from "@khanacademy/wonder-blocks-link";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@repo/shared-styles";
import {cssUrl} from "@repo/urls";

import Downloads from "./downloads.tsx";
import Logo from "./logo.tsx";
import VideoCTA from "./video-cta.tsx";

type Props = Record<any, any>;

const PrivacyPolicyLink = () => (
    <Link style={styles.privacyPolicyLink} href="/kids/privacy-policy">
        <Body>{t`Read Our Privacy Policy >`}</Body>
    </Link>
);

export default class Header extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            <View style={styles.container}>
                <View style={styles.logo}>
                    <Logo />
                </View>

                <View style={styles.body}>
                    <View>
                        <VideoCTA />
                        <View style={styles.privacyPolicyDesktop}>
                            <PrivacyPolicyLink />
                        </View>
                    </View>

                    <View style={styles.downloadContainer}>
                        <Downloads />
                        <View style={styles.privacyPolicyMobile}>
                            <PrivacyPolicyLink />
                        </View>
                    </View>
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        backgroundImage: cssUrl("/images/kids/khan-kids-hero-bg-new-www.svg"),
        backgroundSize: "cover",
        backgroundPosition: "center",
        alignItems: "stretch",

        [mediaQueries.smOrSmaller]: {
            backgroundImage: cssUrl(
                "/images/kids/khan-kids-hero-bg-new-mobile-www.svg",
            ),
        },
    },

    logo: {
        alignItems: "center",
    },

    body: {
        flexDirection: "row",
        paddingBottom: 200,
        alignItems: "center",
        justifyContent: "center",

        [mediaQueries.mdOrSmaller]: {
            flexDirection: "column",
            paddingBottom: 80,
        },
    },

    downloadContainer: {
        padding: 40,
    },

    privacyPolicyLink: {
        color: color.offBlack,
    },

    privacyPolicyDesktop: {
        lineHeight: "18px",
        marginTop: 16,
        marginLeft: 5,

        [mediaQueries.mdOrSmaller]: {
            display: "none",
        },
    },

    privacyPolicyMobile: {
        display: "none",

        [mediaQueries.mdOrSmaller]: {
            display: "flex",
            justifyContent: "center",
            marginTop: 14,
            textAlign: "center",
        },
    },
});
